import { STORE_PUBLISH_FIELD_DETAILS } from '../actions/storePublishFieldDetailsActions';;

interface PublishFields {
    region: string,
    product_id: string,
    product_description: string,
    pricing: number,
    country:string,
    province:string,
    origin: string,
    specification: string
}


export let getPublishFieldDetailSelector  =  (state: PublishFields) => {
    return state[STORE_PUBLISH_FIELD_DETAILS];
  };
  